import * as React from 'react';

import _ from 'underscore';

import type {EntityListType} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {colors} from 'shells/colors/colors';
import {SearchBar} from 'shells/search-bar/search-bar';

import styles from './entity-list-search-box.module.css';

type Props = {
    entityType: EntityListType;
    value: string | null | undefined;
    onChange: (arg1: string) => any;
};
type State = {
    value: string;
};

export class EntityListSearchBox extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            value: props.value || '',
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.value !== this.props.value) {
            this.setState({value: nextProps.value || ''});
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevState.value !== this.state.value) {
            this.updateSearch(String(this.state.value));
        }
    }

    render() {
        return (
            <div className={styles.search}>
                <SearchBar
                    onChange={this.handleChange}
                    value={this.state.value}
                    autoFocus={Boolean(this.props.value)}
                    placeholder={`Search ${getMultipleEntityType(this.props.entityType)}…`}
                    isClearable={true}
                    hasBorder={true}
                    styleOptions={{height: 28, borderColor: colors.offWhiteDk}}
                />
            </div>
        );
    }

    handleChange = (newValue: string) => {
        this.setState({value: newValue || ''});
    };

    // @ts-expect-error
    updateSearch = _.debounce((value) => {
        this.props.onChange(value);
    }, 200);
}
